import { Badge, Group, Loader } from '@mantine/core'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import type { TimesForMovie } from '../../api_types.ts'
import { trpc } from '../queryClient.ts'
import { useErrorNotifier } from '../tools/errors.tsx'

export function LocationsShowingMovie({ movieTimes }: { movieTimes: TimesForMovie[] }) {
  const { data: cinemas, isLoading: loadingCinemas, error: cinemaError } = useQuery(trpc.cinema.all.queryOptions())
  useErrorNotifier('Error fetching cinema info', cinemaError)

  const cinemasById = useMemo(() => {
    if (!cinemas) return undefined
    return Object.fromEntries(cinemas.map(cinema => [cinema.id, cinema]))
  }, [cinemas])

  const locations = useMemo(() => {
    const locations = movieTimes
      .map(time => time.cinemaId)
      .map(cinemaId => cinemasById?.[cinemaId]?.location)
      .filter(location => location !== undefined)
    return Array.from(new Set(locations))
  }, [cinemasById, movieTimes])

  if (loadingCinemas) return <Loader size="sm"/>

  return (
    <Group gap="xs">
      {locations.map(location => <Badge key={location}>{location}</Badge>)}
    </Group>
  )
}
